import {
  ClientPlatformAccountSchema,
  ClientPlatformSchema,
  ClientSchema,
} from '@ametista-ai/api-schema';
import { ApiResponse } from '@ametista-ai/api-schema/http/types';
import { JSONObject } from '@ametista-ai/api-schema/json/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/stores/api/apiClient';
import { clientsKeys } from './keys';

export type ClientMutationResponse = {
  client: ClientSchema;
  clientPlatforms: ClientPlatformSchema[];
  clientPlatformAccounts: ClientPlatformAccountSchema[];
};

export function useCreateClient() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: Partial<ClientSchema>) => {
      return apiClient.post<ApiResponse<ClientMutationResponse>>(
        '/v1/clients',
        params as JSONObject
      );
    },
    onSuccess: (response) => {
      if (!response?.data) return;
      queryClient.invalidateQueries({ queryKey: clientsKeys.all });
    },
  });
}
